import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import InvestAsset from '@pages/Group/pages/Portfolio/pages/InvestAsset';
import PostManagement from '@pages/Group/pages/Portfolio/pages/PostManagement';
import PartnerGroup from '@pages/PartnerGroup';
import PartnerGroupDetail from '@pages/PartnerGroup/pages';
import Portfolio from '@pages/PartnerGroup/pages/Portfolio/pages';
import BasicInfo from '@pages/PartnerGroup/pages/Portfolio/pages/BasicInfo';
import CapitalChange from '@pages/PartnerGroup/pages/Portfolio/pages/CapitalChange';
import Customer from '@pages/PartnerGroup/pages/Portfolio/pages/Customer';
import Finance from '@pages/PartnerGroup/pages/Portfolio/pages/Finance';
import GrowthInfo from '@pages/PartnerGroup/pages/Portfolio/pages/GrowthInfo';
import InvestHistory from '@pages/PartnerGroup/pages/Portfolio/pages/InvestHistory';
import Stockholder from '@pages/PartnerGroup/pages/Portfolio/pages/Stockholder';

import PageNotFound from '@components/Common/Error/PageNotFound';

const PartnerRoute = () => {
  return (
    <>
      <Route path="/partner-group" element={<PartnerGroup />} />
      <Route path="/partner-group/:groupId" element={<PartnerGroupDetail />} />
      <Route
        path="/partner-group/:groupId/portfolio/:portfolioId"
        element={<Portfolio />}
      >
        <Route path="" element={<Navigate replace to="basic-info" />} />
        <Route path="basic-info" element={<BasicInfo />} />
        <Route path="invest-history" element={<InvestHistory />} />
        <Route path="stockholder" element={<Stockholder />} />
        <Route path="capital-change" element={<CapitalChange />} />
        <Route path="growth-info" element={<GrowthInfo />} />
        <Route path="customer" element={<Customer />} />
        <Route path="finance" element={<Finance />} />
        <Route path="invest-asset" element={<InvestAsset />} />
        <Route path="post-management" element={<PostManagement />} />
      </Route>
      <Route path="*" element={<PageNotFound isInLayout />} />
    </>
  );
};

export default PartnerRoute;
